module.exports = __webpack_public_path__ + "img/word.30cf4374.svg";